module.exports = __webpack_public_path__ + "img/1.33c64e24.png";